import { HttpErrorResponse } from '@angular/common/http';
import { Tenant } from '@innovation-os-ng/core/models';
import { createAction, props, union } from '@ngrx/store';
import { TENANT_PREFIX } from '../constants';

const setCurrentTenant = createAction(`${TENANT_PREFIX} Set current tenant`, props<{ tenant: Tenant }>());
const setCurrentTenantSlug = createAction(`${TENANT_PREFIX} Set current tenant slug`, props<{ tenantSlug: string }>());

const fetchTenants = createAction(`${TENANT_PREFIX} Fetch tenants that current user is member of`);
const fetchTenantsSuccess = createAction(`${fetchTenants.type} Success`, props<{ tenants: Array<Tenant> }>());
const fetchTenantsError = createAction(`${fetchTenants.type} Error`, props<{ error: HttpErrorResponse }>());

const updateTenant = createAction(
  `${TENANT_PREFIX} Update Tenant`,
  props<{ tenantUri: string; tenantDetails: Partial<Tenant>; metadata: string }>()
);
const updateTenantSuccess = createAction(`${updateTenant.type} Success`, props<{ tenant: Tenant; metadata: string }>());
const updateTenantError = createAction(`${updateTenant.type} Error`, props<{ error: HttpErrorResponse; metadata: string }>());

const deleteTenant = createAction(`${TENANT_PREFIX} Delete Tenant`, props<{ tenantUri: string }>());
const deleteTenantSuccess = createAction(`${deleteTenant.type} Success`);
const deleteTenantError = createAction(`${deleteTenant.type} Error`, props<{ error: HttpErrorResponse }>());

const createTenant = createAction(`${TENANT_PREFIX} Create Tenant`, props<{ tenantSlug: string; tenantName: string }>());
const createTenantSuccess = createAction(`${createTenant.type} Success`, props<{ tenant: Tenant }>());
const createTenantError = createAction(`${createTenant.type} Error`, props<{ error: HttpErrorResponse }>());

const activateTenant = createAction(`${TENANT_PREFIX} Activate Tenant`, props<{ tenantUri: string; metadata: string }>());
const deactivateTenant = createAction(`${TENANT_PREFIX} Deactivate Tenant`, props<{ tenantUri: string; metadata: string }>());

const addTenantToListOfTenants = createAction(`${TENANT_PREFIX} Add tenant to list`, props<{ tenant: Tenant }>());

const onTenants404 = createAction(`${TENANT_PREFIX} 404`);

const reset = createAction(`${TENANT_PREFIX} Reset`);

const all = union({
  setCurrentTenant,
  setCurrentTenantSlug,
  fetchTenants,
  fetchTenantsSuccess,
  fetchTenantsError,
  updateTenant,
  updateTenantSuccess,
  updateTenantError,
  deleteTenant,
  deleteTenantSuccess,
  deleteTenantError,
  createTenant,
  createTenantSuccess,
  createTenantError,
  activateTenant,
  deactivateTenant,
  addTenantToListOfTenants,
  onTenants404,
  reset
});

// exporting the type of actions here to make sure that we can use the correct type in effects
export type TenantActionTypes = typeof all;

export const TenantActions = {
  setCurrentTenant,
  setCurrentTenantSlug,
  fetchTenants,
  fetchTenantsSuccess,
  fetchTenantsError,
  updateTenant,
  updateTenantSuccess,
  updateTenantError,
  deleteTenant,
  deleteTenantSuccess,
  deleteTenantError,
  createTenant,
  createTenantSuccess,
  createTenantError,
  activateTenant,
  deactivateTenant,
  addTenantToListOfTenants,
  onTenants404,
  reset
};
